import React from 'react';
import moment from 'moment';
import DateHelpers from 'helpers/DateHelpers';

const Calendar = ({ month, dates, selectedDate, onSelect, onChangeMonth, maxMonthsLookAhead }) => {

    const getDaysInMonth = (date) => {
        const year = date.getFullYear();
        const monthNum = date.getMonth();
        return new Date(year, monthNum + 1, 0).getDate();
    };
    
    const year = month.getFullYear();
    const monthNum = month.getMonth();
    const daysInMonth = getDaysInMonth(month);
    const firstDayOfMonth = new Date(year, monthNum, 1).getDay();
    const lastDayOfMonth = new Date(year, monthNum, daysInMonth).getDay();
    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const canGoPrev = (new Date(year, monthNum, 1) > new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const canGoNext = (new Date(year, monthNum, 1) < moment().startOf('month').add(maxMonthsLookAhead, 'months').toDate());
    let selectedYear, selectedMonth, selectedDay;
    if (selectedDate) {
        selectedDate = new Date(selectedDate);
        selectedYear = selectedDate.getFullYear();
        selectedMonth = selectedDate.getMonth();
        selectedDay = selectedDate.getDate();
    }

    const renderDays = () => {
        const days = [];

        // Add days from the previous month
        const prevMonthDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
        const prevMonthDate = new Date(year, monthNum - 1, 1);
        const daysInPrevMonth = getDaysInMonth(prevMonthDate);

        for (let i = prevMonthDays; i > 0; i--) {
            days.push(
                <div
                    className="calendar-day different-month"
                    key={`prev-${i}`}
                >
                    {daysInPrevMonth - i + 1}
                </div>
            );
        }

        // Add days from the current month
        for (let day = 1; day <= daysInMonth; day++) {
            const today = new Date();
            const isToday =
                year === today.getFullYear() &&
                monthNum === today.getMonth() &&
                day === today.getDate();
            const isSelected = (year == selectedYear && monthNum == selectedMonth && day == selectedDay);
            const hasAvailability = dates.findIndex(d => d.getDate() == day) != -1;
            const date = DateHelpers.convertUTCDateToLocalDate(new Date(year, monthNum, day));
            
            days.push(
                <div
                    className={`calendar-day ${isToday ? 'today' : ''} ${isSelected ? 'selected' : ''} ${hasAvailability ? 'has-availability' : 'no-availability'}`}
                    key={`current-${day}`}
                    onClick={() => {
                        if (hasAvailability) onSelect(date)
                    }}
                >
                    {day}
                </div>
            );
        }

        // Add days from the next month
        const nextMonthDays = lastDayOfMonth === 7 ? 0 : 7 - lastDayOfMonth;
        for (let i = 1; i <= nextMonthDays; i++) {
            days.push(
                <div
                    className="calendar-day different-month"
                    key={`next-${i}`}
                >
                    {i}
                </div>
            );
        }

        return days;
    };

    const changeMonth = (offset) => {
        const newMonth = moment.utc(month).add(offset, 'months').toDate();
        onChangeMonth(newMonth);
    };

    return (
        <div className="calendar">
            <div className="calendar-header">
                <div>
                    {month.toLocaleString('default', {
                        month: 'long',
                        year: 'numeric'
                    })}
                </div>

                {canGoPrev &&
                    <div className="calendar-nav prev">
                        <button onClick={() => changeMonth(-1)}>
                            <span className="fa fa-chevron-left" />
                        </button>
                    </div>
                }

                {canGoNext &&
                    <div className="calendar-nav next">
                        <button onClick={() => changeMonth(+1)}>
                            <span className="fa fa-chevron-right" />
                        </button>
                    </div>
                }
            </div>
            <div className="calendar-grid-header">
                {dayNames.map(dn =>
                    <div className="calendar-dow" key={dn}>
                        {dn}
                    </div>
                )}
            </div>
            <div className="calendar-grid">{renderDays()}</div>
        </div>
    );
};

export default Calendar;